export function SlideTransition() {
    return {
        onLoad(elements) {
            elements.forEach(element => element.classList.add('slide'));
        },
        onTransition(elements, activeIndex) {
            elements.forEach((element, i) =>
                vendorTransform.bind(element)(`translate(${(i - activeIndex) * 100}%)`));
        },
    };
}

export function FadeTransition() {
    return {
        onLoad(elements) {
            elements.forEach((element) => {
                element.classList.add('fade');
            });
        },
        onTransition(elements, activeIndex) {
            const el = elements[activeIndex];
            if (el.style.opacity === 1) {
                return;
            }
            const show = elements.slice(0, activeIndex + 1);
            show.forEach(target => {
                const element = target;
                element.style.opacity = 1;
            });
            const hide = elements.slice(activeIndex + 1);
            hide.forEach(target => {
                const element = target;
                element.style.opacity = 0;
            });
        },
    };
}

function fadeInactive(elements, activeIndex) {
    elements
        .filter((el, i) => i !== activeIndex)
        .forEach(element => {
            const el = element;
            el.style.opacity = 0.0;
        });
}

function vendorTransform(transform) {
    this.style.WebkitTransform = transform;
    this.style.msTransform = transform;
    this.style.transform = transform;
}

export default {
    slide: SlideTransition(),
    fade: FadeTransition(),
};
